import { TiersForm } from '../types';

export const tiersDefaultConfig: TiersForm = {
  tiersResultsHiddenFor: [],
  configurationTiersHiddenFor: [],
};
